import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { CreditRequestBatchFieldsFragment } from '@/types';
import { FONTS } from '@/styles';
import { formatShortDate, formatTime, momentWithTimezone } from '@/utils/date';
import { PEPPER_SUPPORT_UUID } from '@/constants';
import { Text } from 'react-native';

interface Props {
  creditRequestBatch: CreditRequestBatchFieldsFragment;
}

export const CreditRequestPlacedBy: React.FC<Props> = ({
  creditRequestBatch,
}) => {
  const [styles] = useStyles();

  const placedAt = creditRequestBatch.created_at;
  const placedBy = creditRequestBatch.created_by;
  const placedAtMoment = momentWithTimezone(placedAt);
  const placedByPepper = placedBy?.uuid === PEPPER_SUPPORT_UUID;

  return placedAt && placedBy && !placedByPepper ? (
    <Text numberOfLines={2} style={styles.employeeName}>
      {i18n.t('requested_by_on_at', {
        date: formatShortDate(placedAtMoment),
        name: placedBy.supplier_employee_overrides[0]?.name ?? placedBy.name,
        time: formatTime(placedAtMoment),
      })}
    </Text>
  ) : null;
};

const useStyles = createStyles((theme) => ({
  employeeName: {
    ...FONTS.primary,
    color: theme.colors.primary,
    fontSize: 14,
    lineHeight: 26,
  },
}));
